
import { Module } from '../core';

export default class ModuleShare extends Module {

    constructor() {
        super('share');
    }
}
